import { mapKeys } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Col, Form, FormControl, FormGroup } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { generateURL, showToast } from '../../utils/helper';
import APISelector from '../Custom/APISelector';
import { session } from '../../Service/APIService';
import { AccessContext } from '../../contexts/AccessProvider';
class Login extends Component {
  static contextType = AccessContext;
  constructor(props) {
    super(props);
    this.state = {
      fields: { userName: '', password: '' },
      errors: '',
      isLoad: false,
    };
  }

  onLoginButtonClick = () => {
    if (this.handleValidation()) {
      this.setState({ isLoad: true });
      const { fields } = this.state;
      const details = {
        username: fields.userName,
        password: fields.password,
        feui: '#####',
      };

      let formBody = [];
      mapKeys(details, (val, key) => {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(val);
        formBody.push(`${encodedKey}=${encodedValue}`);
      });

      formBody = formBody.join('&');
      const currentAction = this;
      const GENERIC_URL = generateURL();
      const URL = `${GENERIC_URL}/token`;
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBody,
      };
      fetch(URL, config)
        .then((response) => response.json())
        .then(async (data) => {
          if (data.statusCode === undefined) {
            const userObj = {
              memberId: data.id,
              fName: data.fName,
              lName: data.lName,
              clientname: data.clientName,
              profilepic: data.profilePicturePath,
              clientLogo: data.clientLogPath,
              username: data.username,
              email: data.email,
              role: data.role,
              roleId: data.roleId,
              token: data.token,
              aliveTill: data.aliveTill,
              clientName: data.clientName,
              clientLogPath: data.clientLogPath,
              profilePicturePath: data.profilePicturePath,
              brandLogo: data.appBrand,
              clientId: data.clientId,
              circleId: data.circleId,
              sectionId: data.sectionId,
              divisionId: data.divisionId,
              subDivisionId: data.subDivisionId,
              substationId: data.substationId,
              townId: data.townId,
              showRTUHealthTab: !!data.showRTUHealthTab,
              showAssetTab: !!data.showAssetTab,
              showOutageTab: !!data.showOutageTab,
              showNetworkTab: !!data.showNetworkTab,
              showGDSData: !!data.showGDSData,
              showPQData: !!data.showPQData,
              showSubstationHealthTab: !!data.showSubstationHealthTab,
              msg: data.memberAccessLvlMsg,
              showTitle: data.showTitle || '',
            };
            session.setClient(data.clientId);
            session.setUser(userObj);
            await this.context.getPageAccess();
            showToast(
              data.roleId === 1
                ? 'You are logged in as Super User'
                : 'Login Successful...!'
            );

            const search = new URLSearchParams(window.location.search);
            const redirectTo = search.get('redirectTo');
            if (redirectTo) {
              window.location.href = redirectTo;
              return;
            }

            if (fields.userName !== 'demouser@orxagrid.com') {
              currentAction.props.history.push('/dashboard');
            } else {
              setTimeout(
                () =>
                  currentAction.props.history.push('/dashboard?loginType=demo'),
                1000
              );
            }
            // Unhide Provide Feedback? option on this page
            this.displayFeedback(true);
          } else if (data.statusCode === 403) {
            currentAction.setState({ isLoad: false });
            showToast(data.message, 'error');
          }
        })
        .catch((error) => {
          currentAction.setState({ isLoad: false });
          showToast(error.message, 'error');
        });
    }
  };

  handleValidation() {
    const { fields } = this.state;
    let formIsValid = true;
    let errors = '';
    if (!fields.userName) {
      formIsValid = false;
      errors = 'Please enter username';
    } else if (!fields.password) {
      formIsValid = false;
      errors = 'Please enter password';
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleChange(field, e) {
    const { fields } = this.state;
    fields[field] = e.target.value;
    this.setState({ fields });
  }

  displayFeedback = (isDisplay) => {
    const displayVal = isDisplay ? 'block' : 'none';
    setTimeout(() => {
      const feedbackComps = document.getElementsByClassName('atlwdg-trigger');
      if (feedbackComps.length > 0) {
        const feedbackComp = feedbackComps[0];
        feedbackComp.style.display = displayVal;
      }
    }, 400);
  };

  render() {
    return (
      <Form horizontal id="defaultPage" className="align-bottom">
        <p className="invalid">&nbsp;{this.state.errors}</p>
        {!this.props.isTPL && <APISelector></APISelector>}
        <FormGroup controlId="formHorizontalUserId">
          <Col sm={12}>
            <FormControl
              type="text"
              placeholder="User Name"
              required="required"
              onChange={this.handleChange.bind(this, 'userName')}
              value={this.state.fields.userName}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="formHorizontalPassword">
          <Col sm={12}>
            <FormControl
              type="password"
              autoComplete="false"
              placeholder="Password"
              required="required"
              onChange={this.handleChange.bind(this, 'password')}
              value={this.state.fields.password}
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="frmButton">
          <Col sm={12}>
            {this.state.isLoad ? (
              <Button
                bsStyle={this.props.isTPL ? 'orange' : 'success'}
                block
                disabled
              >
                <i className="fa fa-refresh fa-spin"></i>
              </Button>
            ) : (
              <Button
                bsStyle={this.props.isTPL ? 'orange' : 'success'}
                type="submit"
                block
                onClick={this.onLoginButtonClick}
              >
                Log In
              </Button>
            )}
          </Col>
        </FormGroup>

        {/* <FormGroup controlId="frmtxt">
                    <div className="text-center">
                        {this.props.isTPL ?
                            <Link to="/forgotpassword"><span style={{ color: "white" }}>Forgot Password </span></Link>
                            :
                            <Link to="/forgotpassword"><span>Forgot Password </span></Link>}
                    </div>
                </FormGroup> */}
      </Form>
    );
  }
}
Login.propTypes = {
  isTPL: PropTypes.bool,
};

export default withRouter(Login);
